import { render, staticRenderFns } from "./BlackCurrentConsumeV2.vue?vue&type=template&id=61e490c0&scoped=true"
import script from "./BlackCurrentConsumeV2.vue?vue&type=script&lang=js"
export * from "./BlackCurrentConsumeV2.vue?vue&type=script&lang=js"
import style0 from "./BlackCurrentConsumeV2.vue?vue&type=style&index=0&id=61e490c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e490c0",
  null
  
)

export default component.exports